export enum PacketStatus {
  MISSING_INFO = 'Missing Info',
  SUBMITTED = 'Submitted',
  RESUBMITTED = 'Resubmitted',
  STARTED = 'Started',
  ACCEPTED = 'Accepted',
  CONDITIONAL = 'Conditional',
  NOT_STARTED = 'Not Started',
  AGE_ISSUE = 'Age Issue',
  NOT_SUBMITTED = 'Not Submitted',
}
